import { RootState } from '@atredux/store'
import { IAlertOptionsType } from '@atredux/slices/atAlertSlice'

export const getAlertOptions = (state: RootState): IAlertOptionsType =>
    state.alert.alertOptions
export const getAlertOpen = (state: RootState): boolean => {
    return state.alert.alertOpen
}
export const getMIOpen = (state: RootState): boolean => {
    return state.alert.MIOpen
}
export const getIdlePromptOpen = (state: RootState): boolean => {
    return state.alert.idlePromptOpen
}
